import { getNamedAnalysis } from "routes/sfg20-admin/plugins/system-info/activity-tab/controller/get-named-analysis"
import React from "react"
import { AnalysisTimeSeriesGraph } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/analysis-time-series-graph"

export function SessionsByHour({ reportDuration, granularity }) {
    const data =
        getNamedAnalysis.useResults("metric-by-hour", reportDuration, granularity, { metric: "session-start" }) ?? {}

    if (!data.results) {
        return <>Loading</>
    }

    const { results } = data
    const sortedResults = [...results].sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp))
    const graphData = sortedResults.map(({ timeStamp, recordCount }) => ({
        x: timeStamp,
        y: recordCount,
    }))

    return (
        <AnalysisTimeSeriesGraph
            granularity={granularity}
            options={{ fullWidth: true }}
            title={`Sessions per ${granularity} - Last ${reportDuration} day(s)`}
            label="Sessions"
            data={graphData}
        />
    )
}
